<app-ad-reports-table [suppressPageTotals]="true"
                      [suppressSizeColumnToFit]="false"
                      [readonly]="readonly"
                      (onDragStop)="onDragStop($event)"
                      (onTableChanges)="onTableChanges($event)"></app-ad-reports-table>
